import React, { useEffect, useRef, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  reveal: {
    opacity: 0,
    transform: "translateY(26px)",
    transition:
      "opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1), transform 0.8s cubic-bezier(0.22, 1, 0.36, 1)",
    willChange: "opacity, transform",
    "@media (prefers-reduced-motion: reduce)": {
      opacity: 1,
      transform: "none",
      transition: "none",
    },
  },
  shown: {
    opacity: 1,
    transform: "translateY(0)",
  },
}));

/**
 * Fades + slides children in the first time they scroll into view.
 * `delay` (ms) staggers siblings. Falls back to always-visible when
 * IntersectionObserver is unavailable.
 */
function Reveal({ children, delay = 0, className = "", style, ...rest }) {
  const classes = useStyles();
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || typeof IntersectionObserver === "undefined") {
      setShown(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShown(true);
          observer.disconnect();
        }
      },
      { threshold: 0.12, rootMargin: "0px 0px -48px 0px" }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`${classes.reveal} ${shown ? classes.shown : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms`, ...style }}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Reveal;